import React, { memo, useId } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import logo from '../../assets/img/content/logo-new.webp';

import style from './style.module.css';

const LOGO_WIDTH = 240;
const LOGO_HEIGHT = 28;
const PATTERN_WIDTH = 480;
const PATTERN_HEIGHT = 200;

const LogoPatternComponent = ({ className }) => {
  const patternId = `logoPattern${useId().replace(/:/g, '')}`;

  return (
    <svg aria-hidden="true" className={classNames(style.host, className)}>
      <defs>
        <pattern height={PATTERN_HEIGHT} id={patternId} patternUnits="userSpaceOnUse" width={PATTERN_WIDTH}>
          <image height={LOGO_HEIGHT} href={logo} width={LOGO_WIDTH} x="0" y="0" />
          <image height={LOGO_HEIGHT} href={logo} width={LOGO_WIDTH} x={LOGO_WIDTH} y={PATTERN_HEIGHT / 2} />
          <image height={LOGO_HEIGHT} href={logo} width={LOGO_WIDTH} x={-LOGO_WIDTH} y={PATTERN_HEIGHT / 2} />
        </pattern>
      </defs>
      <rect fill={`url(#${patternId})`} height="100%" width="100%" />
    </svg>
  );
};

LogoPatternComponent.propTypes = {
  className: PropTypes.string,
};

/**
 * Semi-transparent repeating brand logo background.
 * Fills the nearest positioned ancestor; content siblings must be positioned to stay above it.
 */
export const LogoPattern = memo(LogoPatternComponent);
